import { styled } from "@mui/material/styles";
import { Button, CircularProgress } from "@mui/material";
import {
  dangerColor,
  dangerColor10,
  darkTextColor as textColor,
  secondaryTextColor,
  primaryColor,
  primaryColor10,
  textOnPrimary,
  // @ts-ignore
} from "../../scss/colors.module.scss";
// @ts-ignore
import { customFontSizeNormal } from "../../scss/fonts.module.scss";

export const StyledButton = styled(Button)<{
  customColor?: "danger" | "neutralPrimary" | "neutralSecondary";
  dense?: boolean;
  hidden?: boolean;
  variant?: "text" | "outlined" | "contained";
}>(({ theme, customColor, dense, hidden, variant }) => ({
  padding: dense ? "4px 8px" : "8px 22px",
  display: "flex",
  alignItems: "center",
  fontSize: customFontSizeNormal,
  fontWeight: "bold",
  lineHeight: "20px",
  textTransform: "none",
  color: variant === "contained" && !customColor ? textOnPrimary : textColor,
  ...(variant === "contained" &&
    !customColor && {
      backgroundColor: primaryColor,
      "&:hover": {
        backgroundColor: primaryColor,
        filter: "brightness(0.95)",
      },
      "&.Mui-disabled": {
        color: secondaryTextColor,
        backgroundColor: primaryColor10,
      },
    }),
  width: "fit-content",
  borderColor: primaryColor,
  borderRadius: "4px",
  visibility: hidden ? "hidden" : "visible",
  ...(variant !== "contained" && {
    "&:hover": {
      backgroundColor: primaryColor10,
    },
  }),

  // Danger variant styles
  ...(customColor === "danger" && {
    borderColor: dangerColor,
    color: dangerColor,
    "&:hover": {
      borderColor: dangerColor,
      backgroundColor: dangerColor10,
    },
  }),

  // Neutral Primary variant styles (dark bg → light text)
  ...(customColor === "neutralPrimary" && {
    border: "none",
    backgroundColor: "var(--neutralPrimaryColor)",
    color: "var(--textOnSecondary)",
    "&:hover": {
      border: "none",
      backgroundColor: "var(--neutralPrimaryColor)",
      color: "var(--textOnSecondary)",
    },
    "&:disabled": {
      border: "none",
      backgroundColor: "var(--neutralPrimaryColor)",
      color: secondaryTextColor,
    },
  }),

  // Neutral Secondary variant styles
  ...(customColor === "neutralSecondary" && {
    backgroundColor: "transparent",
    border: "1px solid var(--neutralSecondaryColor)",
    color: "var(--darkTextColor)",
    "&:hover": {
      border: "1px solid var(--neutralSecondaryColor)",
      backgroundColor: "transparent",
      color: "var(--darkTextColor)",
    },
  }),

  "&:disabled": {
    color: secondaryTextColor,
  },

  "& .MuiButton-endIcon, & .MuiButton-startIcon": {
    color:
      customColor === "danger"
        ? dangerColor
        : customColor === "neutralPrimary"
          ? "var(--textOnSecondary)"
          : customColor === "neutralSecondary"
            ? "var(--darkTextColor)"
            : variant === "contained"
              ? textOnPrimary
              : primaryColor,
    "&.Mui-disabled": {
      color: secondaryTextColor,
    },
  },
}));

export const StyledCircularProgress = styled(CircularProgress)(() => ({
  color: "black !important",
}));
